import { useMemo } from "react";
import { useActiveBranches } from "@/hooks/useActiveBranches";
import { useBookConditions } from "@/hooks/useBookConditions";
import { useCatalogSettings } from "@/hooks/useCatalogSettings";
import { useCollections } from "@/hooks/useCollections";
import { useItemStatuses } from "@/hooks/useItemStatuses";
import { useItemTypes } from "@/hooks/useItemTypes";
import { useLocations } from "@/hooks/useLocations";

export function useJournalCatalogOptions() {
  const { data: itemTypesRaw = [], isLoading: loadingTypes } = useItemTypes(true);
  const { data: locationsRaw = [], isLoading: loadingLocations } = useLocations(true);
  const { data: collectionsRaw = [], isLoading: loadingCollections } = useCollections(true);
  const { data: conditionsRaw = [], isLoading: loadingConditions } = useBookConditions(true);
  const { data: itemStatuses = [], isLoading: loadingStatuses } = useItemStatuses();
  const { data: settingsData, isLoading: loadingSettings } = useCatalogSettings();
  const { data: branches = [] } = useActiveBranches();
  const itemTypes = useMemo(() => itemTypesRaw.filter((item) => item.isActive), [itemTypesRaw]);
  const locations = useMemo(
    () => locationsRaw.filter((location) => location.isActive),
    [locationsRaw]
  );
  const collections = useMemo(
    () => collectionsRaw.filter((collection) => collection.isActive),
    [collectionsRaw]
  );
  const conditions = useMemo(
    () =>
      conditionsRaw
        .filter((condition) => condition.isActive)
        .sort((left, right) => left.order - right.order),
    [conditionsRaw]
  );
  return {
    itemTypes,
    locations,
    collections,
    conditions,
    itemStatuses,
    branches,
    settings: settingsData ?? {
      accessionNumberMode: "AUTO" as const,
      approvalWorkflow: "disabled" as const,
    },
    loading:
      loadingTypes ||
      loadingLocations ||
      loadingCollections ||
      loadingConditions ||
      loadingStatuses ||
      loadingSettings,
  };
}

export type JournalCatalogOptions = ReturnType<typeof useJournalCatalogOptions>;
